<template>
    <div
        v-show="visible"
        class="fixed bottom-4 md:bottom-12 right-4 md:right-20 flex justify-center items-center w-12 md:w-16 h-12 md:h-16 rounded bg-black-900 cursor-pointer"
        @click="scrollToTop">
        <Icon name="chevron-up" class="w-4 h-4 stroke-current text-white" />
    </div>
</template>

<script lang="ts">
import Icon from './Icon.vue';

export default {
    components: { Icon },
    props: {
        threshold: {
            type: Number,
            default: 2,
        },
    },
    data() {
        return {
            contentHeight: 0,
            viewportHeight: 0,
            scrollingToTop: false,
            /*
             * the higher the negative delta (= the lower the number) the faster the user needs to scroll to the top
             * to trigger the back button (if height threshold is reached)
             */
            MAX_NEGATIVE_DELTA: -5,
            lastScrollY: 0, // Added to track position reliably
        };
    },
    computed: {
        visible(): boolean {
            return this.thresholdReached && this.scrollingToTop;
        },
        thresholdReached(): boolean {
            return this.contentHeight > this.threshold * this.viewportHeight;
        },
    },
    mounted(): void {
        this.updateHeights();
        // Always listen; let 'visible' handle the logic based on height
        window.addEventListener('scroll', this.handleScrollLogic);
        window.addEventListener('resize', this.updateHeights);
    },
    beforeUnmount() {
        // Clean up
        window.removeEventListener('scroll', this.handleScrollLogic);
        window.removeEventListener('resize', this.updateHeights);
    },
    methods: {
        updateHeights() {
            this.contentHeight = document.body.clientHeight;
            this.viewportHeight = window.innerHeight;
        },
        scrollToTop(): void {
            window.scroll({ top: 0, behavior: 'smooth' });
        },
        handleScrollLogic() {
            const currentScrollY = window.scrollY;
            const delta = currentScrollY - this.lastScrollY;
            this.lastScrollY = currentScrollY;

            // Reset logic
            if (delta > 0 || currentScrollY < window.innerHeight / 2) {
                this.scrollingToTop = false;
            } else if (!this.scrollingToTop) {
                // Trigger based on speed constant
                this.scrollingToTop = delta <= this.MAX_NEGATIVE_DELTA;
            }
        },
    },
};
</script>
